import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
// import CheckwatchModal from './CheckwatchModal';
// import classnames from 'classnames';
import "./Components.css";
import CloseDay from "./CloseDay";

export default function Uhrencheck(props) {
  const [checkWatches, setCheckWatches] = useState([]);
  const [updateCheckWatchTable, setUpdateCheckWatchTable] = useState(false);
  const [collectedCheckedWatches, setCollectedCheckedWatches] = useState([]);
  const [checkWatchProblemtextareaValue, setCheckWatchProblemtextareaValue] =
    useState();
  const [watchProblemInvoiceId, setWatchProblemInvoiceId] = useState(0);
  const [watchmultipleorderIds, setWatchMultipleorderIds] = useState([]);

  //start of docAlertModal realated states and function
  const [checkWatchAlertModal, setCheckAlertModal] = useState(false);
  const checkWatchAlertToggle = () => setCheckAlertModal(!checkWatchAlertModal);

  //   start of Modal realated states and function
  const {
    // buttonLabel,
    className,
  } = props;

  // const [modal, setModal] = useState(false);
  // const [modalIndex, setModalIndex] = useState(-1);
  // const toggle = () => {
  //     setModal(!modal)
  // };

  const [nestedModal, setNestedModal] = useState(false);
  const [boxImageSrc, setBoximageSrc] = useState();
  const BoxtoggleNested = (imgSrc) => {
    setNestedModal(!nestedModal);
    setBoximageSrc(imgSrc);
  };

  //start of problem Modal realated states and function

  const [checkWatchProblemmodal, setCheckWatchProblemmodal] = useState(false);
  const checkWatchProblemtoggle = () =>
    setCheckWatchProblemmodal(!checkWatchProblemmodal);

  const [PmodalwatchCheckProblemList, setPmodalwatchCheckProblemList] =
    useState([]);
  const [
    checkWatchpProblemDetailInvoiceId,
    setcheckWatchpProblemDetailInvoiceId,
  ] = useState();
  const [checkWatchPupdateTriger, setPUpdateTrigerOfcheckatch] =
    useState(false);

  const [checkWatchPPmodal, setcheckWatchPModal] = useState(false);
  const checkWatchToggleP = () => setcheckWatchPModal(!checkWatchPPmodal);

  const checkWatchProblemsdetailsHandler = (data) => {
    // for (let i = 1; i <= data.problems.length; i++) {
    //      element.push(data.problems[i]);
    //     setmodalProblemList(element)
    // }
    setPmodalwatchCheckProblemList(data.problems);
    setcheckWatchpProblemDetailInvoiceId(data.invoiceId);
  };

  const checkWatchsolvePHandler = (problem, problemId, problemDesc, index) => {
    const ProblemSolved = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${checkWatchpProblemDetailInvoiceId}/${problemId}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              solved: true,
              Description: problemDesc,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setPUpdateTrigerOfcheckatch(!checkWatchPupdateTriger);
          let toRemove = problem;
          // console.log(toRemove);
          let index = PmodalwatchCheckProblemList.indexOf(toRemove);
          if (index > -1) {
            //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
            PmodalwatchCheckProblemList.splice(index, 1);
            //   if (index === 0) {
            //     checkWatchToggleP()
            //   }
            let counterOfProblem = 0;
            PmodalwatchCheckProblemList.forEach(function (arraItem) {
              // Expected '===' and instead saw '=='
              if (arraItem.solved === false) {
                ++counterOfProblem;
              }
            });
            if (counterOfProblem < 1) {
              checkWatchToggleP();
            }
          }
          // console.log(PmodalwatchCheckProblemList);
          //   if (index < 1) {
          //     checkWatchToggleP();
          //   }
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    ProblemSolved();
  };

  const fetchPaperApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/watchToTest/9999`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setCheckWatches(payload);
      console.log(payload)
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const CheckWatchProblemInvoiceIdHandler = (invoiceID) => {
    setWatchProblemInvoiceId(invoiceID);
  };

  const handleDocTextareaChange = (event) => {
    setCheckWatchProblemtextareaValue(event.target.value);
  };

  const checkWatchProblemHandler = async (e) => {
    if (checkWatchProblemtextareaValue !== null) {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${watchProblemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: checkWatchProblemtextareaValue,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateCheckWatchTable(!updateCheckWatchTable);
          setCheckWatchProblemtextareaValue(null);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error "+ response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    }
  };

  const watchCheckOkHandler = (invoice, data) => {
    if (data.invoiceIdsInOrder.length > 1) {
      // alert("this order has more than 1 item. \n" + " " + "it contains following order ids: \n" + data.invoiceIdsInOrder);
      setWatchMultipleorderIds(data.watchIdsInOrder);
      checkWatchAlertToggle();
    }
    const CheckWatchPost = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/status/${invoice}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              StatusName: "watchTested",
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateCheckWatchTable(!updateCheckWatchTable);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    CheckWatchPost();
  };

  const fetchDocPhisicallyCollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/watchTested/9999`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setCollectedCheckedWatches(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchPaperApi();
    fetchDocPhisicallyCollectedApi();
  }, [updateCheckWatchTable, checkWatchPupdateTriger]);

  return (
    <div className="container customContainer">
      <CloseDay />
      <Badge className="mb-4" variant="info">
        <h1 className="h3">Uhrencheck</h1>
      </Badge>
      <Row>
        <Col sm="12">
          <div>
            <p>
              Checkliste, noch offen: <strong>{checkWatches.length}</strong>{" "}
              Uhren
            </p>
            <Table bordered striped hover>
              <thead>
                <tr>
                  <th>Digits</th>
                  <th>Auftrag</th>
                  <th>Bild</th>
                  <th>Preis</th>
                  <th>Bezeichnung</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {console.log(checkWatches)}
                {checkWatches.map((data, index) => {
                  return (
                    <tr key={index}>
                      {/* <th scope="row">{data.locationOfWatch}</th> */}
                      <td>
                        {data.statusDbDigit}{" "}
                        {data.hasProblem ? (
                          <i
                            onClick={() => {
                              checkWatchToggleP();
                              checkWatchProblemsdetailsHandler(data);
                            }}
                            id="problem"
                            className="fas fa-exclamation-circle"
                          ></i>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{data.orderId}</td>
                      <td>
                        <img
                          className="ordeImgs"
                          onClick={() => {
                            BoxtoggleNested(data.watchPhotoPath);
                          }}
                          src={data.watchPhotoPath}
                          alt="img"
                        />
                      </td>
                      <td>
                        € {data.priceAmount}
                        <strong style={{ display: "inline", marginLeft: '8px' }}><Badge color="warning" style={{ fontSize: "100%" }}>{data.saleChannelC24DV ? "C24" : "ZA"}</Badge></strong>
                      </td>
                      <td>{data.saleTitle}</td>
                      <td
                        style={
                          data.invoiceIdsInOrder.length > 1
                            ? { backgroundColor: "#ffc107" }
                            : {}
                        }
                      >
                        <div className="displayFlex">
                          <Button
                            color="primary"
                            onClick={() => {
                              watchCheckOkHandler(data.invoiceId, data);
                            }}
                          >
                            OK
                          </Button>{" "}
                          <div>
                            <Button
                              color="danger"
                              className="ml-3"
                              onClick={() => {
                                checkWatchProblemtoggle();
                                setCheckWatchProblemtextareaValue(null);
                                CheckWatchProblemInvoiceIdHandler(
                                  data.invoiceId
                                );
                              }}
                            >
                              Problem
                            </Button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tbody>
                {collectedCheckedWatches.length > 0 && (
                  <tr className="tbodyDivider">
                    <th colSpan="6">
                      Geprüft: {collectedCheckedWatches.length} Uhren
                    </th>
                  </tr>
                )}
                {collectedCheckedWatches.map((collectedDoc, index) => {
                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: "#00FA9A	",
                        color: "#212529",
                        opacity: "0.8",
                      }}
                    >
                      {/* <th scope="row">{collectedDoc.locationOfWatch}</th> */}
                      <td>
                        {collectedDoc.statusDbDigit}{" "}
                        {collectedDoc.hasProblem ? (
                          <i
                            id="problem"
                            className="fas fa-exclamation-circle"
                          ></i>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{collectedDoc.orderId}</td>
                      <td>
                        <img
                          className="ordeImgs"
                          onClick={() => {
                            BoxtoggleNested(collectedDoc.watchPhotoPath);
                          }}
                          src={collectedDoc.watchPhotoPath}
                          alt="img"
                        />
                      </td>
                      <td>
                        € {collectedDoc.priceAmount}
                        <strong style={{ display: "inline", marginLeft: '8px' }}><Badge color="warning" style={{ fontSize: "100%" }}>{collectedDoc.saleChannelC24DV ? "C24" : "ZA"}</Badge></strong>
                      </td>
                      <td>{collectedDoc.saleTitle}</td>
                      <td
                        style={
                          collectedDoc.invoiceIdsInOrder.length > 1
                            ? { backgroundColor: "#ffc107" }
                            : {}
                        }
                      ></td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
      <Modal
        size="lg"
        centered={true}
        isOpen={checkWatchProblemmodal}
        toggle={checkWatchProblemtoggle}
        className={className}
      >
        <ModalHeader toggle={checkWatchProblemtoggle}>
          Problem melden
        </ModalHeader>
        <ModalBody>
          <textarea
            style={{ width: "100%", height: "100px" }}
            onChange={handleDocTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              checkWatchProblemHandler();
              checkWatchProblemtoggle();
            }}
          >
            Problem speichern
          </Button>{" "}
          <Button color="secondary" onClick={checkWatchProblemtoggle}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={checkWatchAlertModal}
        centered={true}
        toggle={checkWatchAlertToggle}
        className={className}
      >
        <ModalHeader toggle={checkWatchAlertToggle}>
          Achtung! Auftrag enthält mehrere Uhren.
        </ModalHeader>
        <ModalBody>
          <p>
            Dieser Auftrag beinhaltet mehrere Uhren. Bitte Uhren aus dem Auftrag
            gemeinsam einsortieren.
            <br />
            Interne Nummern in diesem Auftrag:
          </p>
          {
            <ul>
              {watchmultipleorderIds.map((txt, index) => (
                <li key={index}>
                  <b>{txt}</b>
                </li>
              ))}
            </ul>
          }
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            style={{ color: "#212529" }}
            onClick={checkWatchAlertToggle}
          >
            OK
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={nestedModal}
        toggle={BoxtoggleNested}
        // onClosed={closeAll ? toggle : undefined}
      >
        {/* <ModalHeader>Nested Modal title</ModalHeader> */}
        <ModalBody>
          <img className="nestedImage" src={boxImageSrc} alt="Box" />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={BoxtoggleNested}>
            OK
          </Button>{" "}
          {/* <Button color="secondary" onClick={toggleAll}>All Done</Button> */}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={checkWatchPPmodal}
        toggle={checkWatchToggleP}
        className={className}
      >
        <ModalHeader toggle={checkWatchToggleP}>Problemdetails</ModalHeader>
        <ModalBody>
          <div>
            <ol
              style={{ maxHeight: "300px", overflow: "auto", paddingLeft: "0" }}
            >
              {PmodalwatchCheckProblemList.map((problem, index) => {
                if (!problem.solved) {
                  return (
                    <div
                      key={index}
                      // style={ (solvedClicked && solvedClickedIndex === index) ? { display: "none"} : {}}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          marginRight: "10px",
                        }}
                      >
                        <p>
                          <span style={{ paddingRight: "16px" }}>
                            <b>{problem.personName}:</b>
                          </span>
                          {problem.description}
                        </p>
                        {/* {modalProblemList} */}
                        <Button
                          color="success"
                          className="ml-3"
                          onClick={() => {
                            checkWatchsolvePHandler(
                              problem,
                              problem.id,
                              problem.description,
                              index
                            );
                          }}
                        >
                          Problem gelöst
                        </Button>
                      </li>
                      <hr></hr>
                    </div>
                  );
                }
                return null;
              })}
            </ol>
          </div>
          {/* <textarea style={{ width: '100%', height: '100px' }} placeholder="In case of new problem, please write your comment here"
                        onChange={handleProblemTextareaChange}
                        autoFocus={true} ></textarea> */}
        </ModalBody>
        {/* <ModalFooter style={{ justifyContent: "space-between" }}>
                    <Button color="primary" onClick={() => { updateProblemHandler(); checkWatchToggleP() }}>Update the problem</Button>{' '}
                    <Button color="danger" onClick={() => {cancelHandler(); checkWatchToggleP();}}>Cancel item</Button>
                    <Button color="secondary" onClick={checkWatchToggleP}>Close</Button>
                </ModalFooter> */}
      </Modal>
    </div>
  );
}
